import { render, staticRenderFns } from "./VacationDialog.vue?vue&type=template&id=be82bda2"
import script from "./VacationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./VacationDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports